// ABOUTME: Adds the tab's active market header to a header map, used by the Apollo `setContext` link.
// ABOUTME: Keeps GraphQL deterministic regardless of how the upload link binds fetch.

import { getActiveMarketId } from '../activeMarketStore';
import { ACTIVE_MARKET_HEADER } from '../constants';

/**
 * Returns the headers with `x-active-market` added, or unchanged when no market is stored. A
 * market already set by the operation (an explicit choice, e.g. a job dialog) wins.
 */
export const withActiveMarketHeader = <T extends Record<string, string> | undefined>(
    headers: T,
): T | Record<string, string> => {
    if (headers?.[ACTIVE_MARKET_HEADER]) return headers;
    const market = getActiveMarketId();
    return market ? { ...headers, [ACTIVE_MARKET_HEADER]: market } : headers;
};
